import CmsBlock from "@/helpers/editor/blocks/CmsBlock.js";
import CmsComponentImage from "@/helpers/editor/components/CmsComponentImage.js";
import CmsComponentText from "@/helpers/editor/components/CmsComponentText.js";

export default class CmsBlockKioskHeader extends CmsBlock {
    static typeDef = {
        name: `Kiosk Header|En-tête kiosque`,
        type: `kiosk-header`,
        category: `widget`,
        glyph: `fa-browser`,
        isParent: false
    }

    constructor(data) {
        super(data);
        const logoHasActive = this.logo?.active !== undefined;
        this.logo = new CmsComponentImage(this.logo);
        const hasTitle = this.title !== undefined;
        this.title = new CmsComponentText(this.title);
        if (!hasTitle) {
            this.title.preset = `h4`;
        }

        if (this.showLogo !== undefined) {
            this.logo.active = this.showLogo;
            delete this.showLogo;
        } else if (!logoHasActive) {
            this.logo.active = false;
        }
        this.timeStyle = this.mergeDefaults(this.timeStyle, {fontSize: 1.5, fontWeight: 600, color: `default`});
        this.dateStyle = this.mergeDefaults(this.dateStyle, {fontSize: 0.875, fontWeight: 400, color: `default`});

        if (!data) {
            this.padding.top = 12;
            this.padding.right = 20;
            this.padding.bottom = 12;
            this.padding.left = 20;
            this.container = CmsBlock.CONTAINERS.FILL_WIDTH;
            this.logo.maxWidth = 150;
            this.logo.maxHeight = 48;
        }
    }

    initNewBlock(website) {
        super.initNewBlock(website);
        this.container = CmsBlock.CONTAINERS.FILL_WIDTH;
    }
}
